// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"ad12907e","220":"53fe3db2","484":"47678af1","608":"5529da8b","653":"4f9cbe0b","744":"9874834e"}[chunkId] + ".chunk.css";
};